import { ErrorText } from "../statics/error-text";

/**
 * User-facing message for a failed request. The backend throws GraphQL errors
 * whose message is an error key (e.g. "StatementImport.InvalidState"); unknown
 * keys fall back to the lib's default message.
 */
export const getErrorMessage = (
  error: unknown,
  errorText: ErrorText,
): string => {
  const key = error instanceof Error ? error.message : undefined;
  return (
    (key && errorText[key]?.message) || errorText["default"]?.message || ""
  );
};
